import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const encryptData = (data) => {
  try {
    const text = JSON.stringify(data);
    if (!text) throw new Error("Invalid data for encryption");
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  } catch (err) {
    console.error("Encryption failed:", err);
    return null;
  }
};

const decryptData = (ciphertext) => {
  try {
    if (!ciphertext) return null;
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedText ? JSON.parse(decryptedText) : null;
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
};

export const secureStorage = {
  setItem: (key, value) => {
    const encrypted = encryptData(value);
    if (encrypted) localStorage.setItem(key, encrypted);
  },

  getItem: (key) => {
    const item = localStorage.getItem(key);
    return item ? decryptData(item) : null;
  },

  removeItem: (key) => localStorage.removeItem(key),
  clear: () => localStorage.clear(),
};
